import { render, staticRenderFns } from "./FormNewsletter.vue?vue&type=template&id=2f185a94&"
import script from "./FormNewsletter.vue?vue&type=script&lang=js&"
export * from "./FormNewsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports